//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

let timeOutSearch = null;
export default {
  name: 'CustomAutocompleteServices',

  data: function () {
    return {
      options: [],

      searchItems: [],
      search: "",

      isOpen: false,
      isLoading: false,
      isLoadSearch: false
    }
  },

  props: {
    value: {},
    api: {
      type: String,
      default: ""
    },

    customOptions: {
      type: Array,
      default: () => {
        return []
      }
    },
    isUseCustomOptions: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    enterOptions: function () {
      if (String(this.search || '').length > 0) {
        return this.searchItems
      }
      return this.options
    },

    serviceIcon: function () {
      if (this.isOpen) {
        return null
      }
      const _selected = this.options.find((t) => Boolean(String(t?.external_id || t?.value) === String(this.value)));
      if (!_selected?.icon_id) {
        return null
      }
      return String(_selected?.icon_id)
    },
    serviceName: function () {
      if (this.isOpen) {
        return this.$t('documentationApi.select')
      }
      const _selected = this.options.find((t) => Boolean(String(t?.external_id || t?.value) === String(this.value)))
      return String(_selected?.name || _selected?.label || this.$t('documentationApi.select'))
    }
  },

  watch: {
    search: function () {
      this.isLoadSearch = Boolean(String(this.search).length > 0)
      clearTimeout(timeOutSearch);
      timeOutSearch = setTimeout(() => {
        this.setSearchItems();
      }, 1000);
    }
  },

  methods: {
    getOptions: async function () {
      if (this.isUseCustomOptions) {
        this.options = this.customOptions;
        return
      }
      if (this.isLoading || this.options.length > 0) {
        return
      }

      this.isLoading = true;
      const apiUrl = String(this.api || '').split("/api").pop();
      const res = await this.$api.agent.transport.get(apiUrl)
        .then((res) => (res?.data || []))
        .catch(() => []);

      this.options = res;
      this.isLoading = false;
    },

    changeOpen: function (value) {
      this.isOpen = value;
      if (!value) {
        this.search = "";
        this.searchItems = [];
      } else {
        (async () => {
          await this.getOptions();
        })();
      }
    },
    changeItem: function (item) {
      this.$emit("change", item);
      this.changeOpen(false);
    },

    setSearchItems: function () {
      const search = String(this.search || "").toLowerCase();
      if (search.length <= 0) {
        this.searchItems = [];
        return
      }

      this.isLoadSearch = true;
      let items = this.options;
      if (this.useCustomOptions) {
        items = this.customOptions;
      }
      this.searchItems = items.filter((item) => {
        const _name = String(item?.name || '').toLowerCase();
        return Boolean(String(_name || '').includes(search))
      })

      this.isLoadSearch = false;
    },
  }
}
